import { excelAPI } from "../api";
import { getParams } from "../api/getParams";

const DOWNLOAD_EXCEL_REQUEST = 'DOWNLOAD_EXCEL_REQUEST';
const DOWNLOAD_EXCEL_SUCCESS = 'DOWNLOAD_EXCEL_SUCCESS';

const initialState = {
  downloading: false,
};

const downloadExcelReducer = (state = initialState, action) => {
  switch (action.type) {
    case DOWNLOAD_EXCEL_REQUEST:
      return { 
        ...state, 
        downloading: true,
      }
    case DOWNLOAD_EXCEL_SUCCESS:
      return { 
        ...state, 
        downloading: false,
      }
    default: return state
  }
}

export default downloadExcelReducer

const downloadExcelRequest = () => ({ type: DOWNLOAD_EXCEL_REQUEST });
const downloadExcelSuccess = () => ({ type: DOWNLOAD_EXCEL_SUCCESS });

// filters — те же filter[...], что уходят в список учеников (user/)
export const downloadExcel = (filters = []) => dispatch => {
  dispatch(downloadExcelRequest())
  excelAPI.getExcelTable({ url: `user/export${getParams({ filter: filters })}`, responseType: 'blob' })
  .then(res => {
      dispatch(downloadExcelSuccess())
      if (!res?.status || res.status < 200 || res.status >= 300) return

      const url = window.URL.createObjectURL(new Blob([res.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'data.xlsx')
      document.body.appendChild(link)
      link.click()
    })
    .catch(() => {
      dispatch(downloadExcelSuccess())
    })
}

export const selectorExcelDownloader = state => state.excel
